import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiClipboardCheck } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const SsuMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (
      !(
        user.roles_names.includes("View Service Qualification") ||
        user.roles_names.includes("Edit Service Qualification") ||
        user.roles_names.includes("View Vendor Qualification") ||
        user.roles_names.includes("Edit Vendor Qualification") ||
        user.roles_names.includes("View Management Systems") ||
        user.roles_names.includes("Edit Management Systems")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="ssu"
          onClick={() => handleClick("ssu")}
          title={t("menu.ssu.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiClipboardCheck} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.ssu.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon icon={openSubmenu.ssu ? mdiChevronUp : mdiChevronDown} />
        </ListItemButton>
        <Collapse in={openSubmenu.ssu} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {(user.roles_names.includes("View Management Systems") ||
              user.roles_names.includes("Edit Management Systems")) && (
              <HybridRouteListItemButtonLink
                caption="ssu management system"
                isReact={false}
                name="ssu[managementSystem]"
                sx={{ pl: 4 }}
                title={t("menu.ssu.submenu.managementSystem.title")}
                url="/vqualif/management_systems"
              >
                <ListItemText
                  primary={t("menu.ssu.submenu.managementSystem.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {(user.roles_names.includes("View Service Qualification") ||
              user.roles_names.includes("Edit Service Qualification")) && (
              <HybridRouteListItemButtonLink
                caption="ssu service qualification"
                isReact={false}
                name="ssu[serviceQualification]"
                sx={{ pl: 4 }}
                title={t("menu.ssu.submenu.serviceQualification.title")}
                url="/vqualif/service_qualifications"
              >
                <ListItemText
                  primary={t("menu.ssu.submenu.serviceQualification.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {(user.roles_names.includes("View Vendor Qualification") ||
              user.roles_names.includes("Edit Vendor Qualification")) && (
              <HybridRouteListItemButtonLink
                caption="ssu vendor qualification"
                isReact={false}
                name="ssu[vendorQualification]"
                sx={{ pl: 4 }}
                title={t("menu.ssu.submenu.vendorQualification.title")}
                url="/vqualif/vendor_qualifications"
              >
                <ListItemText
                  primary={t("menu.ssu.submenu.vendorQualification.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}

            {(user.roles_names.includes("View Management Systems") ||
              user.roles_names.includes("Edit Management Systems")) && (
              <HybridRouteListItemButtonLink
                caption="ssu management system report"
                isReact={false}
                name="ssu[managementSystemReport]"
                sx={{ pl: 4 }}
                title={t("menu.ssu.submenu.managementSystemReport.title")}
                url="/vqualif/management_systems/report"
              >
                <ListItemText
                  primary={t("menu.ssu.submenu.managementSystemReport.title")}
                  slotProps={{
                    primary: { sx: { fontSize: 14 } },
                  }}
                  sx={{ whiteSpace: "normal" }}
                />
              </HybridRouteListItemButtonLink>
            )}
          </List>
        </Collapse>
      </>
    );
  },
);
